import React from "react";
import SubBanner from "./components/SubBanner";
import ProductsSection from "./components/ProductsSection";

function Products() {
  return (
    <>
      <SubBanner title="Products" />
      <ProductsSection />
    </>
  );
}

export default Products;